// extracted by mini-css-extract-plugin
module.exports = {"top":"Page_top___apdH","faq":"Page_faq__c_swt"};